<div class="absolute inset-0 z-10 rounded-xl flex items-center justify-center bg-surface-0/50">
  <p-progress-spinner strokeWidth="4" class="w-12 h-12"/>
</div>
